import { render, staticRenderFns } from "./PaymentCompletion.vue?vue&type=template&id=447c3e04&"
import script from "./PaymentCompletion.vue?vue&type=script&lang=js&"
export * from "./PaymentCompletion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports